// import { Breadcrumbs } from "@mui/material";
// import React from "react";
// import { Link } from "react-router-dom";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";

// export default function BreadCrumbs({ items }) {
//   return (
//     <div className="breadcrumb breadcrumb-container">
//       <Breadcrumbs
//         aria-label="breadcrumb"
//         separator={<ChevronRightIcon className="m-0" />}
//       >
//         {items.map((item, index) => {
//           return (
//             <>
//               {item.path ? (
//                 <Link
//                   to={item.path}
//                   style={{
//                     color: item.active ? "#DAA520" : "gray",
//                   }}
//                   className="bread-crum"
//                 >
//                   {item.name}
//                 </Link>
//               ) : (
//                 <span
//                   style={{
//                     color: item.active ? "#DAA520" : "gray",
//                     fontSize: "15px",
//                     fontWeight: "bold",
//                   }}
//                   className="bread-crum"
//                 >
//                   {item.name}
//                 </span>
//               )}
//             </>
//           );
//         })}
//       </Breadcrumbs>
//     </div>
//   );
// }

const BreadCrumbs = () => {
  return <div></div>;
};

export default BreadCrumbs;
